function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 6
}, /*#__PURE__*/React.createElement("path", {
  d: "M127.928 38.8c-30.75 0-55.768 25.017-55.768 55.767s25.018 55.767 55.768 55.767 55.768-25.017 55.768-55.767S158.678 38.8 127.928 38.8zm0 96.533c-22.479 0-40.768-18.288-40.768-40.767S105.449 53.8 127.928 53.8s40.768 18.288 40.768 40.767-18.288 40.766-40.768 40.766z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.928 0C75.784 0 33.362 42.422 33.362 94.566c0 30.072 25.22 74.875 40.253 98.904 9.891 15.809 20.52 30.855 29.928 42.365 15.101 18.474 20.506 20.02 24.386 20.02 3.938 0 9.041-1.547 24.095-20.031 9.429-11.579 20.063-26.616 29.944-42.342 15.136-24.088 40.527-68.971 40.527-98.917C222.495 42.422 180.073 0 127.928 0zm43.641 181.803c-19.396 31.483-37.203 52.757-43.73 58.188-6.561-5.264-24.079-26.032-43.746-58.089-22.707-37.015-35.73-68.848-35.73-87.336C48.362 50.693 84.055 15 127.928 15s79.566 35.693 79.566 79.566c.001 18.382-13.094 50.178-35.925 87.237z"
}));

function SvgThumbStop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 22,
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 255.856 255.856"
  }, props), _ref);
}

export default SvgThumbStop;